export default function MySQL_ABS() {
  return (
    <div>
      <h2>MySQL_ABS</h2>    </div>
  );
}